import type { Theme } from './types';

export const cleanDarkTheme: Theme = {
  name: 'Clean Dark',
  id: 'clean-dark',
  colours: {
    background: {
      primary: '#0a0a0f',
      secondary: '#12121a',
      tertiary: '#1a1a25',
      elevated: '#222230',
    },
    text: {
      primary: '#f0f0f5',
      secondary: '#b0b0c0',
      tertiary: '#707080',
      inverse: '#0a0a0f',
    },
    accent: {
      primary: '#3b82f6',
      secondary: '#8b5cf6',
      success: '#22c55e',
      warning: '#f59e0b',
      error: '#ef4444',
    },
    feedback: {
      placed: '#22c55e',
      misplaced: '#f59e0b',
      incorrect: '#6b7280',
    },
    rarity: {
      common: '#6b7280',
      uncommon: '#22c55e',
      rare: '#3b82f6',
      epic: '#a855f7',
      legendary: '#fbbf24',
    },
    powerUp: {
      boost: '#f59e0b',
      surge_i: '#ef4444',
      surge_ii: '#ec4899',
      oracle: '#8b5cf6',
    },
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  typography: {
    fontFamily: '"Inter", system-ui, -apple-system, sans-serif',
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      md: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      xxl: '1.5rem',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    lineHeight: {
      tight: 1.25,
      normal: 1.5,
      relaxed: 1.75,
    },
  },
  borders: {
    radius: {
      sm: '0.25rem',
      md: '0.5rem',
      lg: '0.75rem',
      full: '9999px',
    },
    width: {
      thin: '1px',
      normal: '2px',
      thick: '3px',
    },
  },
  shadows: {
    sm: '0 1px 2px rgba(0, 0, 0, 0.3)',
    md: '0 4px 6px rgba(0, 0, 0, 0.4)',
    lg: '0 10px 15px rgba(0, 0, 0, 0.5)',
    xl: '0 20px 25px rgba(0, 0, 0, 0.6)',
    glow: '0 0 20px rgba(59, 130, 246, 0.3)',
  },
  transitions: {
    fast: '150ms ease-in-out',
    normal: '300ms ease-in-out',
    slow: '500ms ease-in-out',
  },
  scanlineAlpha: 0,
  vignetteEnabled: false,
  fontFamily: '"Inter", system-ui, -apple-system, sans-serif',
  rarityColours: {
    common: '#6b7280',
    uncommon: '#22c55e',
    rare: '#3b82f6',
    epic: '#a855f7',
    legendary: '#fbbf24',
  },
  powerUpColours: {
    oracle: '#8b5cf6',
    surge: '#ef4444',
    boost: '#f59e0b',
  },
};
